(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        class: "nx-button-group-" + _vm.type
      }, [_vm._t("default")], 2);
    },
    name: 'nx-button-group',
    props: {
      type: {
        type: String,
        default: 'vertical',
        validator: function validator(value) {
          return ['vertical', 'horizontal'].indexOf(value) > -1;
        }
      }
    }
  };
  _exports.default = _default;
});